import { render } from "./CustomerLedger.vue?vue&type=template&id=4474ed96&scoped=true"
import script from "./CustomerLedger.vue?vue&type=script&lang=js"
export * from "./CustomerLedger.vue?vue&type=script&lang=js"

import "./CustomerLedger.vue?vue&type=style&index=0&id=4474ed96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4474ed96"]])

export default __exports__